import React, { createContext, useState } from 'react';

export const LayoutWrapper = createContext({});

export const LayoutProvider = ({ children }) => {
  const [isContainerSliding, setIsContainerSliding] = useState(
    localStorage.getItem('containerState') === 'false' ||
      localStorage.getItem('containerState') === null
      ? false
      : true
  );

  const handleContainerSliding = () => {
    localStorage.setItem('containerState', !isContainerSliding);
    setIsContainerSliding(!isContainerSliding);
  };

  return (
    <LayoutWrapper.Provider
      value={{
        isContainerSliding,
        setIsContainerSliding,
        handleContainerSliding
      }}
    >
      {children}
    </LayoutWrapper.Provider>
  );
};
